import { combineReducers } from "redux";
import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import pincode from "../features/admin/masters/pincode/Slice";
import area from "../features/admin/masters/area/Slice";
import orientation from "../features/admin/masters/orientation/Slice";
import printinglocations from "../features/admin/masters/printing-locations/Slice";
import materials from "../features/admin/masters/materials/Slice";
import laminations from "../features/admin/masters/laminations/Slice";
import shapes from "../features/admin/masters/shapes/Slice";
import partners from "../features/admin/masters/partners/Slice";
import qty from "../features/admin/masters/qty/Slice";
import envelopes from "../features/admin/masters/envelopes/Slice";
import whychooseus from "../features/admin/masters/whychooseus/Slice";
import industry from "../features/admin/masters/industry/Slice";
import department from "../features/admin/masters/department/Slice";
import companysize from "../features/admin/masters/companysize/Slice";
import faqs from "../features/admin/masters/faqs/Slice";
import subfaqSlice from "../features/admin/masters/subfaq/subfaqSlice";
import socialmedia from "../features/admin/masters/socialmedia/Slice";
import coupons from "../features/admin/masters/coupons/Slice";
import privacyandpolicy from "../features/admin/masters/privacyandpolicy/Slice";
import returnpolicy from "../features/admin/masters/returnpolicy/Slice";
import termsandconditions from "../features/admin/masters/termsandconditions/Slice";
import careers from "../features/admin/masters/careers/Slice";
import blog_categories from "../features/admin/masters/blog_categories/Slice";
import blogs from "../features/admin/masters/blogs/Slice";
import pravachans from "../features/admin/masters/pravachan/slice";
import sizes from "../features/admin/masters/sizes/Slice";
import help from "../features/admin/masters/help/Slice";
import insightVideo from "../features/admin/masters/insight/video/slice";
import insightArticle from "../features/admin/masters/insight/article/slice";
import insightAudio from "../features/admin/masters/insight/audio/slice";
import insightExclusive from "../features/admin/masters/insight/exclusive/slice";
import spandan from "../features/admin/masters/spandan/slice";
import qoute_of_the_day from "../features/admin/masters/qoute_of_the_day/slice";
import guruji_wisdom from "../features/admin/masters/guruji_wisdom/slice";
import our_core_vision from "../features/admin/masters/our_core_vision/slice";
import spandanSession from "../features/admin/masters/spandan/spandan_session/slice";
import spandanBanner from "../features/admin/masters/spandan/spandan_banner/slice";
import spandanVideo from "../features/admin/masters/spandan/spandan_video/slice";
import donation from "../features/admin/masters/explore/donation/slice";
import volunteering from "../features/admin/masters/explore/volunteering/slice";

import todaysPath from "../features/admin/masters/home/todays_path/slice";
import meditaionBenefit from "../features/admin/masters/home/meditation_benefit/slice";
import meditaionEssence from "../features/admin/masters/home/meditation_essence/slice";
import meditaionGuideline from "../features/admin/masters/home/meditation_guideline/slice";
import gurudevShorts from "../features/admin/masters/home/gurudev_shorts/slice";
import spiritualTruth from "../features/admin/masters/home/spiritual_truth/slice";
import seva from "../features/admin/masters/home/seva/slice";
import ourOfferings from "../features/admin/masters/home/our_offerings/slice";
import testimonial from "../features/admin/masters/home/testimonial/slice";

import chant from "../features/admin/masters/chant/Chantslice";
import chant_type from "../features/admin/masters/chant/ChantTypeSlice";
import languages from "../features/admin/masters/languge/slice";
import levels from "../features/admin/masters/level/slice";
import spiritualInsights from "../features/admin/masters/spiritual_insights/slice";
import homeBanners from "../features/admin/masters/home_banner/slice";
import storeBanners from "../features/admin/masters/store_banner/slice";
import event_category from "../features/admin/masters/home/Event_category/slice";

import event_type from "../features/admin/masters/home/Event_type/slice";

import event from "../features/admin/masters/home/Event/slice";

import event_program from "../features/admin/masters/home/Event_program/slice";

import volunteer_position from "../features/admin/masters/volunteer_position/slice";
import days_of_service from "../features/admin/masters/days_of_service/slice";
import hours_of_service from "../features/admin/masters/hours_of_service/slice"
import unit from "../features/admin/masters/unit/slice";
import roomType from "../features/admin/masters/room_type/slice";
import contact_us_centres from "../features/admin/masters/contact_us_centres/slice";
import donation_cancellation_refund_policies from "../features/admin/masters/donation_cancellation_refund_policies/Slice";
import shipping_delivery_policies from "../features/admin/masters/shipping_delivery_policies/Slice";
import about_us from "../features/admin/masters/about_us/slice";
import gender from "../features/admin/masters/gender/slice";
import frame_category from "../features/admin/masters/frame_category/slice";
import appsetup from "../features/admin/masters/app_setup/slice";
import sociallink from "../features/admin/masters/social_link/slice";
import volunteer_details from "../features/admin/masters/volunteer/Slice"
import donation_details from "../features/admin/masters/donationdetails/Slice"


import festival from "../features/admin/masters/home/festival/slice";

import welcomeText from "../features/admin/masters/welcome_text/slice";
import gurudev_contents from "../features/admin/masters/gurudev_contents/slice";
import our_mission from "../features/admin/masters/our_mission/slice";
import our_vission from "../features/admin/masters/our_vission/slice";
import at_om_tapovan from "../features/admin/masters/at_om_tapovan/slice";
import room_cancel_reason from "../features/admin/masters/room_cancel_reason/slice";
import cancel_reason from "../features/admin/masters/cancel_reason/slice";
import return_reason from "../features/admin/masters/return_reason/slice";
import frame from "../features/admin/masters/frame/slice";
import shared_experiences from "../features/admin/masters/shared_experiences/slice";
import concent_and_term from "../features/admin/masters/concent_and_terms/Slice";







const masters = combineReducers({
  country: country,
  levels: levels,
  state: state,
  city: city,
  pincode: pincode,
  area: area,
  orientation: orientation,
  printinglocations: printinglocations,
  materials: materials,
  laminations: laminations,
  shapes: shapes,
  partners: partners,
  qty: qty,
  envelopes: envelopes,
  whychooseus: whychooseus,
  industry: industry,
  department: department,
  companysize: companysize,
  faqs: faqs,
  subfaq: subfaqSlice,
  socialmedia: socialmedia,
  coupons: coupons,
  privacyandpolicy: privacyandpolicy,
  returnpolicy: returnpolicy,
  termsandconditions: termsandconditions,
  careers: careers,
  blog_categories: blog_categories,
  blogs: blogs,
  pravachans: pravachans,
  sizes: sizes,
  help: help,
  insightVideo: insightVideo,
  insightAudio: insightAudio,
  insightArticle: insightArticle,
  insightExclusive: insightExclusive,
  spandan: spandan,
  qoute_of_the_day: qoute_of_the_day,
  guruji_wisdom: guruji_wisdom,
  our_core_vision: our_core_vision,
  spandanSession: spandanSession,
  spandanVideo: spandanVideo,
  spandanBanner: spandanBanner,
  donation: donation,
  volunteering: volunteering,
  roomType: roomType,

  todaysPath: todaysPath,
  meditaionBenefit: meditaionBenefit,
  meditaionEssence: meditaionEssence,
  meditaionGuideline: meditaionGuideline,
  gurudevShorts: gurudevShorts,
  spiritualTruth: spiritualTruth,
  seva: seva,
  ourOfferings: ourOfferings,
  testimonial: testimonial,

  chant: chant,
  chant_type: chant_type,
  languages: languages,
  spiritualInsights: spiritualInsights,
  homeBanners: homeBanners,
  storeBanners: storeBanners,
  event_category: event_category,
  event: event,
  unit: unit,
  event_type: event_type,
  event_program: event_program,
  contact_us_centres: contact_us_centres,
  donation_cancellation_refund_policies: donation_cancellation_refund_policies,
  shipping_delivery_policies: shipping_delivery_policies,
  about_us: about_us,
  volunteer_position: volunteer_position,
  days_of_service: days_of_service,
  hours_of_service: hours_of_service,
  gender: gender,
  appsetup: appsetup,
  sociallink: sociallink,
  volunteer_details: volunteer_details,
  donation_details: donation_details,

  festival: festival,
  welcomeText: welcomeText,

  gurudev_contents: gurudev_contents,
  at_om_tapovan: at_om_tapovan,
  our_vission: our_vission,
  our_mission: our_mission,
  room_cancel_reason: room_cancel_reason,
  cancel_reason: cancel_reason,
  return_reason: return_reason,

  frame: frame,
  frame_category: frame_category,
  shared_experiences: shared_experiences,
  concent_and_term: concent_and_term,
});

export default masters;
